// Lib
import React, { useCallback } from 'react';
import MobileEmojiSheet from '../../../emoji/popup/MobileEmojiSheet';
import { UseSheetReturnType } from '../../../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../../i18n/useTranslator';
import { useSelector } from 'react-redux';
import getGridSize from '../../../../utils/grid/gridSizeSelector';

type MobileCalloutEmojiSheetProps = {
    selectedEmojiId: string;
    sheetProps: UseSheetReturnType;
    onSelectEmoji: (emojiId: string) => void;
    closeSheet: () => void;
};

const MobileCalloutEmojiSheet: React.FC<MobileCalloutEmojiSheetProps> = (props) => {
    const { sheetProps, selectedEmojiId, closeSheet } = props;
    const gridSize = useSelector(getGridSize);
    const translate = useTranslator('popup', 'emoji.callout');

    const onSelectEmoji = useCallback((emojiId: string) => {
        props.onSelectEmoji?.(emojiId);
        sheetProps.closeSheet();
    }, []);

    return (
        <MobileEmojiSheet
            {...props}
            heading={translate('chooseIcon')}
            sheetProps={sheetProps}
            selectedEmojiIds={[selectedEmojiId]}
            onSelectEmoji={onSelectEmoji}
            closePopup={closeSheet}
            gridSize={gridSize}
        />
    );
};

export default MobileCalloutEmojiSheet;
